// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__dvQv4","avatar":"style_avatar__1reTF","menuIcon":"style_menuIcon__Xg3Kp"};